import React from 'react';
import { Backdrop, CircularProgress, Modal } from '@material-ui/core';

import { ContainerBase, Centered, Title } from './styles';

export function Container({
  isLoading = false,
  isError = false,
  children,
  loadingType = 'inPage',
  ...rest
}) {
  if ((isLoading && loadingType === 'inPage') || isError) {
    return (
      <ContainerBase>
        <Centered>
          {isLoading && <CircularProgress />}
          <Title>{isError ? 'Falha ao carregar.' : 'carregando...'}</Title>
        </Centered>
      </ContainerBase>
    );
  }

  return (
    <ContainerBase {...rest}>
      <Modal
        open={isLoading && loadingType === 'modal'}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Backdrop open>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Modal>

      {children}
    </ContainerBase>
  );
}

export default Container;
